import { Tabs } from "antd"
import { BrazilianCreditBonds } from "./BrazilianCreditBonds"
import { HedgeFundsDashboard } from "./HedgeFundsDashboard"

export const Screening = () => {
  const items = [
    {
      key: "1",
      path: "screening/debentures",
      label: "Debêntures",
      children: <BrazilianCreditBonds />,
    },
    {
      key: "2",
      path: "screening/hedge-funds",
      label: "Hedge Funds",
      children: <HedgeFundsDashboard />,
    },
  ]

  return <Tabs defaultActiveKey="1" items={items} />
}
